define("calendar/components/calendar/settings/bttp/followers", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <h5 class="u--text--md u--m__b__xs u--m__t__0" data-test-id="bttp-followers">
    {{svg-jar "warning" class="o--icon o--icon--warning u--m__r__xs"}}
    {{t "bttp.more_followers_required_title"}}
  </h5>
  <p class="u--text--light u--m__b" data-test-id="bttp-followers-user-info">
    {{html-safe
      (t
        "bttp.more_followers_required_details"
        nickname=@nickname
        followers=@numberOfFollowers
        required_followers=@requiredFollowers
        profile_type=@profileType
      )
    }}
    {{#if this.isTiktok}}
      <Shared::Link
        @href="https://help.later.com/hc/articles/7948787987863"
        @text={{t "shared_phrases.learn_more"}}
        data-test-id="bttp-followers-is-tiktok"
      />
    {{/if}}
  </p>
  {{#unless @isOnLegacyPlan}}
    <Calendar::Settings::Bttp::InfoCard />
  {{/unless}}
  */
  {
    "id": "CvtGYRDH",
    "block": "[[[10,\"h5\"],[14,0,\"u--text--md u--m__b__xs u--m__t__0\"],[14,\"data-test-id\",\"bttp-followers\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"warning\"],[[\"class\"],[\"o--icon o--icon--warning u--m__r__xs\"]]]],[1,\"\\n  \"],[1,[28,[35,1],[\"bttp.more_followers_required_title\"],null]],[1,\"\\n\"],[13],[1,\"\\n\"],[10,2],[14,0,\"u--text--light u--m__b\"],[14,\"data-test-id\",\"bttp-followers-user-info\"],[12],[1,\"\\n  \"],[1,[28,[35,2],[[28,[37,1],[\"bttp.more_followers_required_details\"],[[\"nickname\",\"followers\",\"required_followers\",\"profile_type\"],[[30,1],[30,2],[30,3],[30,4]]]]],null]],[1,\"\\n\"],[41,[30,0,[\"isTiktok\"]],[[[1,\"    \"],[8,[39,4],[[24,\"data-test-id\",\"bttp-followers-is-tiktok\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/7948787987863\",[28,[37,1],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"],[41,[51,[30,5]],[[[1,\"  \"],[8,[39,6],null,null,null],[1,\"\\n\"]],[]],null]],[\"@nickname\",\"@numberOfFollowers\",\"@requiredFollowers\",\"@profileType\",\"@isOnLegacyPlan\"],false,[\"svg-jar\",\"t\",\"html-safe\",\"if\",\"shared/link\",\"unless\",\"calendar/settings/bttp/info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/followers.hbs",
    "isStrictMode": false
  });
  let FollowersComponent = _exports.default = (_class = class FollowersComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor, this);
    }
    get isTiktok() {
      return Boolean(this.selectedSocialProfiles?.firstProfile?.isTiktok);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FollowersComponent);
});